// This file was once generated when you created this area
// but you can edit it freely

import { transformRoutes } from '@backoffice-frontend/common'

const baseRoute = '/safety-driver-annotations'

const BaseSafetyDriverAnnotationsAreaRoutes = {
  route: baseRoute,
  Detail: { route: `${baseRoute}/:id` },
}

export const SafetyDriverAnnotationsAreaRoutes = transformRoutes(
  BaseSafetyDriverAnnotationsAreaRoutes,
)
